import { Component, EventEmitter, Input, Output, OnInit, OnChanges, SimpleChanges, LOCALE_ID } from '@angular/core';
import { CommonModule,registerLocaleData } from '@angular/common';
import { FormBuilder, FormGroup, Validators, ReactiveFormsModule } from '@angular/forms';
import { MatCardModule } from '@angular/material/card';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule , MAT_DATE_LOCALE } from '@angular/material/core';
import { MatIconModule } from '@angular/material/icon';
import { CelebrationJobLocation, Event } from '../../../core/models/event.model';
import { Volunteer } from '../../../core/models/volunteer.model';
import { CargoService } from '../../../core/services/cargo.service';
import localePt from '@angular/common/locales/pt';

registerLocaleData(localePt);

@Component({
  selector: 'app-schedule-step',
  standalone: true,
  imports: [
    CommonModule, ReactiveFormsModule, MatCardModule, MatInputModule, MatButtonModule, MatDatepickerModule, MatNativeDateModule, MatIconModule
  ],
  templateUrl: './schedule-step.component.html',
  styleUrls: ['./schedule-step.component.scss'],
  providers: [
    { provide: LOCALE_ID, useValue: 'pt-BR' },
    { provide: MAT_DATE_LOCALE, useValue: 'pt-BR' }
  ]
})
export class ScheduleStepComponent implements OnInit, OnChanges {
  @Input() event: Event | null = null;
  @Input() volunteer: Volunteer | null = null;
  @Input() jobLocation: CelebrationJobLocation | null = null;
  @Output() confirm = new EventEmitter<any>();
  @Output() back = new EventEmitter<void>();

  dateTimeForm: FormGroup;
  today: Date = new Date();
  currentDuration: number = 0;
  /** Tempo padrão de turno (min) resolvido: cargo do voluntário > jobLocation > 60. */
  effectiveDurationMinutes: number = 60;

  constructor(private fb: FormBuilder, private cargoService: CargoService) {
    this.dateTimeForm = this.fb.group({
      startDate: [this.today, Validators.required],
      startTime: [this.formatTime(this.today), Validators.required],
      endDate: [this.today, Validators.required],
      endTime: [this.formatTime(this.today), Validators.required]
    }, { validators: this.dateRangeValidator });

    // // Atualiza data/hora final automaticamente ao alterar início
    // this.dateTimeForm.get('startDate')?.valueChanges.subscribe(() => {
    //   this.autoSetEndDateTime();
    // });
    // this.dateTimeForm.get('startTime')?.valueChanges.subscribe(() => {
    //   this.autoSetEndDateTime();
    // });
  }



  ngOnInit() {
    if (this.jobLocation) {
      this.resolverDuracaoEAplicar();
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if ((changes['jobLocation'] || changes['volunteer']) && this.jobLocation) {
      this.resolverDuracaoEAplicar();
    }
  }

  /**
   * Resolve o tempo padrão pelo cargo do voluntário (com fallback pro valor
   * fixo do jobLocation) e aplica as datas sugeridas.
   */
  private resolverDuracaoEAplicar() {
    const fixo = this.jobLocation?.defaultJobTimeInMinutes || 60;
    this.cargoService.getDefaultTimeMinutes(this.volunteer?.cargo).subscribe(min => {
      this.effectiveDurationMinutes = min ?? fixo;
      this.aplicarDatasSugeridas();
    });
  }

  private aplicarDatasSugeridas() {
    const start = new Date();
    const end = new Date(start.getTime() + this.effectiveDurationMinutes * 60000);
    this.dateTimeForm.patchValue({
      startDate: start,
      startTime: this.formatTime(start),
      endDate: end,
      endTime: this.formatTime(end)
    });
    this.updateDurationOnChange();
  }

   autoSetEndDateTime() {
    console.log('autoSetEndDateTime called');
    const formValues = this.dateTimeForm.value;
    if (this.effectiveDurationMinutes && formValues.startDate && formValues.startTime) {
      const startDateTime = new Date(formValues.startDate);
      const [sh, sm] = formValues.startTime.split(':');
      startDateTime.setHours(+sh, +sm, 0, 0);
      const endDateTime = new Date(startDateTime.getTime() + this.effectiveDurationMinutes * 60000);
      this.dateTimeForm.patchValue({
        endDate: endDateTime,
        endTime: this.formatTime(endDateTime)
      }, { emitEvent: false });
      this.updateDurationOnChange();
    }
  }

  getMinEndDate() {
    return this.dateTimeForm.value.startDate || this.today;
  }

  updateDurationOnChange() {

    const formValues = this.dateTimeForm.value;
    if (!formValues.startDate || !formValues.startTime) {
      this.currentDuration = 0;
      return;
    }
    // Atualiza data/hora final automaticamente ao alterar início
    if (this.effectiveDurationMinutes) {
      const startDateTime = new Date(formValues.startDate);
      const [sh, sm] = formValues.startTime.split(':');
      startDateTime.setHours(+sh, +sm, 0, 0);
      // Só atualiza se o usuário não mexeu manualmente no final (ou se o final está igual ao início)
      const endDateTime = new Date(startDateTime.getTime() + this.effectiveDurationMinutes * 60000);
      const currentEndDate = new Date(formValues.endDate);
      const [eh, em] = formValues.endTime.split(':');
      currentEndDate.setHours(+eh, +em, 0, 0);
      // Se o final está igual ao início ou não foi alterado, atualiza
      if (
        !formValues.endDate || !formValues.endTime ||
        (currentEndDate.getTime() === new Date(formValues.startDate).setHours(+sh, +sm, 0, 0))
      ) {
        this.dateTimeForm.patchValue({
          endDate: endDateTime,
          endTime: this.formatTime(endDateTime)
        }, { emitEvent: false });
      }
    }
    // Calcula duração normalmente
    if (!formValues.endDate || !formValues.endTime) {
      this.currentDuration = 0;
      return;
    }
    try {
      const startDateTime = new Date(formValues.startDate);
      const [sh, sm] = formValues.startTime.split(':');
      startDateTime.setHours(+sh, +sm, 0, 0);
      const endDateTime = new Date(formValues.endDate);
      const [eh, em] = formValues.endTime.split(':');
      endDateTime.setHours(+eh, +em, 0, 0);
      const diffInMinutes = Math.round((endDateTime.getTime() - startDateTime.getTime()) / (1000 * 60));
      this.currentDuration = diffInMinutes > 0 ? diffInMinutes : 0;
    } catch (error) {
      this.currentDuration = 0;
    }
  }

  formatDuration(minutes: number): string {
    if (!minutes || minutes <= 0) return '0 min';
    const h = Math.floor(minutes / 60);
    const m = minutes % 60;
    return `${h > 0 ? h + 'h ' : ''}${m}min`;
  }

  formatTime(date: Date): string {
    const hours = date.getHours().toString().padStart(2, '0');
    const minutes = date.getMinutes().toString().padStart(2, '0');
    return `${hours}:${minutes}`;
  }

  dateRangeValidator(form: FormGroup) {
    const { startDate, startTime, endDate, endTime } = form.value;
    if (startDate && startTime && endDate && endTime) {
      const start = new Date(startDate);
      const [sh, sm] = startTime.split(':');
      start.setHours(+sh, +sm, 0, 0);
      const end = new Date(endDate);
      const [eh, em] = endTime.split(':');
      end.setHours(+eh, +em, 0, 0);
      return end > start ? null : { dateRange: true };
    }
    return null;
  }

  confirmarCadastro() {
    if (this.dateTimeForm.valid) {
      this.confirm.emit({
        event: this.event,
        volunteer: this.volunteer,
        jobLocation: this.jobLocation,
        ...this.dateTimeForm.value,
        duration: this.currentDuration
      });
    } else {
      this.dateTimeForm.markAllAsTouched();
    }
    console.log('Confirmar Cadastro:', this.event)
  }
}
